export const ChartConfig = {
    animationDuration: 1500
};
